import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAdmin, getBatch, getSection, getType } from '../Redux/BatchSectionReducer/action';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { getLecture, searchLectureAdmin } from '../Redux/LectureReducer/action';
import Navbar from '../components/Navbar';
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { Paginator } from '../utils';
import { Loader } from '../components/Loader';

export const Lecture = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const batch = useSelector((state) => state.BatchSectionReducer.batch);
    const section = useSelector((state) => state.BatchSectionReducer.section);
    const type = useSelector((state) => state.BatchSectionReducer.type);
    const admin = useSelector((state) => state.BatchSectionReducer.admin);
    const token = useSelector((state) => state.AuthReducer.token);
    const loading = useSelector((state) => state.LectureReducer.isLoading)
    const lecturesArray = useSelector((state) => state.LectureReducer.adminLecture)
    const user = useSelector((state) => state.AuthReducer.user);

    //------------------------------- handle search functionality --------------------
    const [title, setTitle] = useState("");
    const [searchBatch, setSearchBatch] = useState("");
    const [searchSection, setSearchSection] = useState("");
    const [searchType, setSearchType] = useState("");
    const [searchDate, setSearchDate] = useState("");
    const [searchUser, setSearchUser] = useState("");
    const [searchDay, setSearchDay] = useState("");
    const [searchWeek, setSearchWeek] = useState("");
    const [searchStartTime, setSearchStartTime] = useState("")

    // -----------pagination state----------------
    const [size, setSize] = useState(1);

    const searchData = {
        "title": title,
        "createdBy": searchUser,
        "startTime": searchStartTime,
        "batchId": searchBatch,
        "sectionId": searchSection,
        "typeId": searchType,
        "day": searchDay,
        "week": searchWeek
    }
    console.log(searchData);
    const lectureDetail = (e) => {
        navigate(`/lecture-detail/${e.lectureId}`, { state: { data: e, from: location.pathname } })
    }
    const createLecture = () => {
        navigate("/create-lecture");
    }
    const createBulkLecture = () => {
        navigate("/createbulklecture")
    }
    const handleView = (e) => {
        navigate(`/lecture-detail/${e.lectureId}`, { state: { data: e, from: location.pathname } })
    }
    const handleEdit = (e) => {
        navigate(`/editLecture/${e.lectureId}`, { state: { data: e, from: location.pathname } })
    }
    const handleDate = (e) => {
        setSearchDate(e);
        let date = e.split("-").join("/");
        setSearchStartTime(`${date} 00:00:00`);
    }
    const handleReset = () => {
        setTitle("");
        setSearchBatch("");
        setSearchSection("");
        setSearchType("");
        setSearchDate("");
        setSearchUser("");
        setSearchWeek("");
        setSearchDay("");
        setSearchStartTime("");
    }

    useEffect(() => {
        const debounceId = setTimeout(() => {
            dispatch(searchLectureAdmin(searchData, token))
        }, 700)
        return () => {
            clearTimeout(debounceId);
        }
    }, [title, searchBatch, searchSection, searchType, searchDate, searchUser, searchWeek, searchDay])

    useEffect(() => {
        dispatch(getSection(token));
        dispatch(getBatch(token));
        dispatch(getType());
        dispatch(getAdmin());
    }, [])

    // ----------------pagination function -------------------
    const perPageItem = 10;
    const pageNumber = Math.ceil(lecturesArray.length / perPageItem);
    const pageArray = new Array(pageNumber).fill().map((v, i) => i + 1);
    const { data, total, page, per_page } = Paginator(
        lecturesArray,
        size,
        perPageItem
    );
    const increment = () => {
        if (size < pageArray.length) {
            setSize(size + 1);
        }
    };
    const decrement = () => {
        if (size > 0) {
            setSize(size - 1);
        }
    };

    return (
        <div className='font-sans antialiased min-h-screen bg-gray-100'>
            <nav>
                <Navbar name={user.name} role={user.roles.name} />
            </nav>
            <header className='bg-white shadow'>
                <div className='max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 flex justify-between'>
                    <h2 className='font-semibold text-xl text-start text-gray-800 leading-tight'>Lectures</h2>
                    <div className='flex gap-2'>
                        <button
                            className='border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold cursor-pointer uppercase '
                            type='Button'
                            onClick={createBulkLecture}
                        >
                            Create bulk Lecture
                        </button>
                        <button
                            className='border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer '
                            type='Button'
                            onClick={createLecture}
                        >
                            create lectures
                        </button>
                    </div>
                </div>
            </header>
            {/*----------- page contend starts here--------------------- */}
            <div className='py-12'>
                <div className='max-w-7xl mx-auto sm:px-6 lg:px-8'>
                    <div className='bg-white m-auto mt-10 sm:mt-0'>
                        <div className='p-6 text-left grid grid-cols-12 gap-6'>
                            <div className='col-span-12'>
                                <input
                                    className='text-sm required:border-red-500 p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    type='text'
                                    placeholder='Title'
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                            <div className='col-span-4'>
                                <select
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    onChange={(e) => setSearchBatch(e.target.value)}
                                    value={searchBatch}
                                >
                                    <option value="">Batch</option>
                                    {
                                        batch.map((e) => {
                                            return <option key={e.id} value={e.id}>{e.batchName}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className='col-span-4'>
                                <select
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    onChange={(e) => setSearchSection(e.target.value)}
                                    value={searchSection}
                                >
                                    <option value="">Section</option>
                                    {
                                        section.map((e) => {
                                            return <option key={e.id} value={e.id}>{e.sectionsName}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className='col-span-4'>
                                <select
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    onChange={(e) => setSearchType(e.target.value)}
                                    value={searchType}
                                >
                                    <option value="">Type</option>
                                    {
                                        type.map((e) => {
                                            return <option key={e.typeId} value={e.typeId}>{e.typeTitle}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className='col-span-3'>
                                <input
                                    className='text-sm required:border-red-500 p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    type='date'
                                    value={searchDate}
                                    onChange={(e) => handleDate(e.target.value)}
                                />
                            </div>
                            <div className='col-span-3'>
                                <select
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    onChange={(e) => setSearchUser(e.target.value)}
                                    value={searchUser}
                                >
                                    <option value="">User</option>
                                    {
                                        admin.map((e) => {
                                            return <option key={e.id} value={e.id}>{e.name}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className='col-span-3'>
                                <select
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    onChange={(e) => setSearchWeek(e.target.value)}
                                    value={searchWeek}
                                >
                                    <option value="">Week</option>
                                    <option value="1">Week-1</option>
                                    <option value="2">Week-2</option>
                                    <option value="3">Week-3</option>
                                    <option value="4">Week-4</option>
                                    <option value="5">Week-5</option>
                                </select>
                            </div>
                            <div className='col-span-3'>
                                <select
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    onChange={(e) => setSearchDay(e.target.value)}
                                    value={searchDay}
                                >
                                    <option value="">Day</option>
                                    <option value="1">Day-1</option>
                                    <option value="2">Day-2</option>
                                    <option value="3">Day-3</option>
                                    <option value="4">Day-4</option>
                                    <option value="5">Day-5</option>
                                    <option value="6">Day-6</option>
                                </select>
                            </div>
                            <div className='col-start-10 col-span-3'>
                                <button
                                    className='border w-full rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer'
                                    type='Button'
                                    onClick={handleReset}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                    {/*------------------ Lecture Listing table starts here ----------------------------- */}
                    <div className=' bg-white p-6'>
                        <table className='w-full'>
                            <thead className='text-gray bg-gray-100 uppercase font-sans antialiased text-sm'>
                                <tr className=' p-1 border-b border-gray-300 text-xs font-medium text-gray-500 w-full grid grid-cols-12 text-left gap-5 '>
                                    <td className='col-span-1'>Id</td>
                                    <td className='col-span-4'>Title</td>
                                    <td className='col-span-2'>Batch</td>
                                    <td className='col-span-2'>Start Time</td>
                                    <td className='col-span-2'>Concludes</td>
                                    <td className='col-span-1'>View & Edit</td>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? <Loader /> : ""}
                                {
                                    data.map((e) => {
                                        const startTimeArray = e.startTime.split(" ");
                                        const startDate = startTimeArray[0];
                                        const startTime = startTimeArray[1];
                                        const concludeTimeArray = e.concludeTime.split(" ");
                                        const concludeDate = concludeTimeArray[0];
                                        const concludeTime = concludeTimeArray[1];

                                        return <tr key={e.lectureId} className=' p-2 border-b border-gray-300 text-xs font-medium grid grid-cols-12 text-left gap-5 '>
                                            <td onClick={() => lectureDetail(e)} className='col-span-1 flex items-center'>
                                                <div className='text-left text-gray-500 text-sm'>
                                                    {e.lectureId}
                                                </div>
                                            </td>
                                            <td onClick={() => lectureDetail(e)} className='col-span-4'>
                                                <div>
                                                    <div className='text-xl font-medium text-black'>
                                                        <span>{e.title}</span>
                                                        <span className='ml-1 uppercase text-xs bg-green-600 text-green-50 p-0.5 rounded px-1'>{e.type}</span>
                                                    </div>
                                                    <span className='flex gap-1'>
                                                        <span>Created By</span>
                                                        <span className='text-black font-bold capitalize'>{e.createdBy}</span>
                                                        <span className='text-black font-bold capitalize'>({e.type})</span>
                                                        <span>at {e.startTime}</span>
                                                    </span>
                                                </div>

                                            </td>
                                            <td onClick={() => lectureDetail(e)} className='col-span-2'>
                                                <div className='text-base uppercase text-black'>
                                                    <span className='font-semibold'>{e.batch}</span>
                                                </div>
                                                {/* <span className='text-sm uppercase text-gray-500'>{e.batch}</span> */}
                                            </td>
                                            <td onClick={() => lectureDetail(e)} className='col-span-2'>
                                                <div className=''>
                                                    <span className='text-sm bg-gray-100 font-bold text-gray-600'>{startDate}</span>
                                                </div>
                                                <span className='text-sm text-gray-600 '>{startTime}</span>
                                            </td>
                                            <td onClick={() => lectureDetail(e)} className='col-span-2'>
                                                <div className=''>
                                                    <span className='text-sm bg-gray-100 font-bold text-gray-600'>{concludeDate}</span>
                                                </div>
                                                <span className='text-sm text-gray-600 '>Time-{concludeTime} {e.type}</span>
                                            </td>
                                            <td className='col-span-1 flex'>
                                                <div className='flex gap-6 items-center'>
                                                    <span
                                                        className='block text-blue-600 font-semibold text-base cursor-pointer'
                                                        onClick={() => handleView(e)}
                                                    >
                                                        View
                                                    </span>
                                                    <span
                                                        className='block text-blue-600 font-semibold text-base cursor-pointer'
                                                        onClick={() => handleEdit(e)}
                                                    >
                                                        Edit
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className=" border-t">
                        <div>
                            <nav
                                role="navigation"
                                className="flex items-center justify-between"
                            >
                                <div className="flex items-center justify-between w-full border-t border-gray-200 bg-white px-4 py-5 sm:px-6">
                                    <div className="flex flex-1 justify-between sm:hidden">
                                        <button
                                            onClick={decrement}
                                            className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
                                        >
                                            Previous
                                        </button>
                                        <button
                                            onClick={increment}
                                            className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
                                        >
                                            Next
                                        </button>
                                    </div>
                                    <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                                        <div>
                                            <p className="text-sm text-gray-700">
                                                Showing{" "}
                                                <span className="font-medium">
                                                    {page * per_page - per_page}
                                                </span>{" "}
                                                to{" "}
                                                <span className="font-medium">
                                                    {data.length > 0 ?Math.min( page * per_page ,total): 0}
                                                </span>{" "}
                                                of{" "}
                                                <span className="font-medium">{total}</span>{" "}
                                                results
                                            </p>
                                        </div>
                                        <div>
                                            <nav
                                                className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                                                aria-label="Pagination"
                                            >
                                                <span className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
                                                    <button
                                                        className="sr-only cursor-pointer"
                                                        onClick={decrement}
                                                    >
                                                        Previous
                                                    </button>
                                                    <ChevronLeftIcon
                                                        className="h-5 w-5"
                                                        aria-hidden="true"
                                                        onClick={decrement}
                                                    />
                                                </span>
                                                {pageArray.length > 0 &&
                                                    pageArray.map((item, i) => {
                                                        return (
                                                            <button
                                                                key={i}
                                                                onClick={() => setSize(item)}
                                                                className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset active:bg-blue-800 active:text-white ring-gray-300 hover:bg-gray-50 focus:z-20 focus:bg-blue-800 focus:text-white cursor-pointer"
                                                            >
                                                                {item}
                                                            </button>
                                                        );
                                                    })}

                                                <span className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
                                                    <span
                                                        className="sr-only"
                                                        onClick={increment}
                                                    >
                                                        Next
                                                    </span>
                                                    <ChevronRightIcon
                                                        className="h-5 w-5"
                                                        aria-hidden="true"
                                                        onClick={increment}
                                                    />
                                                </span>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
